import React from "react";
import LinkedIn from "@mui/icons-material/LinkedIn";
import { SiGoogleads, SiMailchimp, SiPosthog } from "react-icons/si";
import { DEMO_APPS } from "../data/product-demo";

const appMarks = {
  linkedin: LinkedIn,
  posthog: SiPosthog,
  googleads: SiGoogleads,
  mailchimp: SiMailchimp,
};

export default function DemoAppIcon({ id }) {
  const app = DEMO_APPS[id];
  const Mark = appMarks[id];
  return (
    <span
      className={"work-app-icon work-icon-" + id}
      style={{ background: app.color, color: app.iconColor || "#fff" }}
      aria-hidden="true"
    >
      {Mark ? (
        <Mark />
      ) : (
        <img src={"/brand/apps/" + (app.icon || id + ".svg")} alt="" />
      )}
    </span>
  );
}
